export default function objectFromEntries(arr) {
  const obj = {}

  arr.forEach(item => {
    const [key, value] = item
    obj[key] = value
  })

  return obj
}